import { csConstants, siteConstants } from "../../constants";
import { csServices } from "../../services";

const invalidFileSelected = () => {
  return {
    type: csConstants.INVALID_FILE_SELECTED,
    payload: null,
  };
}

const validateReport = (visitorId, report) => {
  const request = (report) => {
    return {
      type: csConstants.VALIDATE_REQUEST,
      payload: { report },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.VALIDATE_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.VALIDATE_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(report));
    csServices.validateReport(visitorId, report)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const getReportValidationStatus = (reportId) => {
  const request = (reportId) => {
    return {
      type: csConstants.VALIDATION_STATUS_REQUEST,
      payload: { reportId },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.VALIDATION_STATUS_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.VALIDATION_STATUS_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(reportId));
    csServices.getReportValidationStatus(reportId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const createOrder = (visitorId, reportId) => {
  const request = (reportId) => {
    return {
      type: csConstants.CREATE_ORDER_REQUEST,
      payload: { reportId },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.CREATE_ORDER_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.CREATE_ORDER_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(reportId));
    csServices.createOrder(visitorId, reportId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const setEmail = (orderId, email) => {
  const request = (orderId, email) => {
    return {
      type: csConstants.SET_EMAIL_REQUEST,
      payload: {
        orderId,
        email,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.SET_EMAIL_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.SET_EMAIL_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(orderId, email));
    csServices.setEmail(orderId, email)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const unsetEmail = () => {
  return {
    type: csConstants.UNSET_EMAIL,
    payload: null,
  }
}

const getBundles = () => {
  const request = () => {
    return {
      type: csConstants.GET_BUNDLES_REQUEST,
      payload: null,
    };
  }

  const success = (data) => {
    return {
      type: csConstants.GET_BUNDLES_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.GET_BUNDLES_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request());
    csServices.getBundles()
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const setBundle = (orderId, bundleId, bundleIndex) => {
  const request = (orderId, bundleId) => {
    return {
      type: csConstants.SET_BUNDLE_REQUEST,
      payload: {
        orderId,
        bundleId,
      },
    };
  }

  const success = (data, bundleIndex) => {
    return {
      type: csConstants.SET_BUNDLE_SUCCESS,
      payload: {
        data,
        bundleIndex,
      },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.SET_BUNDLE_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(orderId, bundleId));
    csServices.setBundle(orderId, bundleId)
      .then(response => {
        const data = response.data;
        dispatch(success(data, bundleIndex));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const chargeCard = (visitorId, stripe, card, nameOnCard, orderId) => {
  const request = (stripe, card, nameOnCard, orderId) => {
    return {
      type: csConstants.CHARGE_CARD_REQUEST,
      payload: {
        stripe,
        card,
        nameOnCard,
        orderId,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.CHARGE_CARD_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.CHARGE_CARD_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(stripe, card, nameOnCard, orderId));
    csServices.createPaymentMethod(stripe, card, nameOnCard)
      .then(response => {
        const { paymentMethod } = response;
        csServices.chargeCard(visitorId, paymentMethod.id, orderId)
          .then(response => {
            const data = response.data;
            if (data.status === "requires_action") {
              stripe.handleCardAction(data.client_secret)
                .then(response => {
                  if (response.error) {
                    dispatch(failure(response.error.message));
                  } else {
                    csServices.confirmCharge(visitorId, response.paymentIntent.id, orderId)
                      .then(response => {
                        const data = response.data;
                        dispatch(success(data));
                      })
                      .catch(error => {
                        dispatch(failure(error.response.data.detail));
                      });
                  }
                })
                .catch(error => {
                  dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
                });
            } else {
              dispatch(success(data));
            }
          })
          .catch(error => {
            dispatch(failure(error.response.data.detail));
          });
      })
      .catch(error => {
        console.error(error);
        dispatch(failure(siteConstants.ERROR_MSG_DEFAULT));
      });
  }
}

const claimThinkificDiscountCode = (visitorId, orderId) => {
  const request = (orderId) => {
    return {
      type: csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_REQUEST,
      payload: {
        orderId,
      },
    };
  }

  const success = (data) => {
    return {
      type: csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_SUCCESS,
      payload: { data },
    };
  }

  const failure = (errorMessage) => {
    return {
      type: csConstants.CLAIM_THINKIFIC_DISCOUNT_CODE_FAILURE,
      payload: { errorMessage },
    };
  }

  return dispatch => {
    dispatch(request(orderId));
    csServices.claimThinkificDiscountCode(visitorId, orderId)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(siteConstants.ERROR_MSG_CLAIM_THINKIFIC_DISCOUNT_CODE_FAILED));
      });
  }
}

export const csActions = {
  invalidFileSelected,
  validateReport,
  getReportValidationStatus,
  createOrder,
  setEmail,
  unsetEmail,
  getBundles,
  setBundle,
  chargeCard,
  claimThinkificDiscountCode,
};